import React, {
    FC, useState, useContext, useRef, MutableRefObject,
    useMemo,
} from 'react';
import cn from 'classnames';

import { analyticService } from 'global/services';

import { NextOverlay } from 'app/views/Menu/Menu/components/CustomIngredientsSelectDishRow/Mobile/overlay/nextOverlay';
import { FrameDialog } from 'app/components/Dialog';
import { UIButton, UIRadioIcon } from 'app/components/ui';

import { LocationContext } from 'app/containers/LocationProvider';
import { on } from 'events';
import css from './MobileCitySelectModal.module.scss';

type TypeProps = {
    isOpen: boolean,
    // eslint-disable-next-line no-unused-vars
    setIsOpen: (value: boolean) => void,
    // eslint-disable-next-line no-unused-vars
    setCityCallback: (value: string) => void,
    cities: any[],
    // eslint-disable-next-line no-unused-vars
    handleSelectedSubdivision?: (value: string) => void,
    showSubmitButton?: boolean
}

export function splitLocationValueFlexible(value: string): any {
    const match = value.match(/(.+?)\s+и\s+(МО|ЛО|область)$/);

    if (match) {
        return {
            full: value,
            main: match[1].trim(),
            suffix: `и ${match[2]}`,
            regionType: match[2],
        };
    }

    return {
        full: value,
        main: value,
        suffix: null,
        regionType: null,
    };
}


export const MobileCitySelectModal: FC<TypeProps> = ({
    isOpen, setIsOpen, setCityCallback, cities,
    handleSelectedSubdivision = () => { },
    showSubmitButton = true,
}: TypeProps) => {
    const {
        mutateAddreessHandler,
        locationKey,
    } = useContext(LocationContext);
    const [selectedOption, setSelectedOption] = useState<string>(locationKey);
    const prevOption: MutableRefObject<string> = useRef<string>(locationKey);
    const submitButtonRef: MutableRefObject<any> = useRef(null);
    const lang = sessionStorage.getItem('lang');

    const handleCloseDialog = (e: any) => {
        e.stopPropagation();
        setIsOpen(false);
    };

    const onCityClickHandler = (e: any, id: string) => {
        e.stopPropagation();
        setSelectedOption((prev) => {
            prevOption.current = prev;
            return id;
        });
    };

    const onCitySumbitHandler = (e: any, passedCityId?: any) => {
        const currentCityId = passedCityId || selectedOption;
        e.stopPropagation();
        const addressString = {
            MSK: 'г Москва',
            SPB: 'г Санкт-Петербург',
            NIZ: 'г Нижний Новгород',
            KZN: 'г Казань',
            TUL: 'г Тула',
            YAR: 'г Ярославль',
            VLA: 'г Владимир',
            RYA: 'г Рязань',
            KLU: 'г Калуга',
            TVE: 'г Тверь',
            VOR: 'г Воронеж',
        };
        // @ts-ignore
        handleSelectedSubdivision(currentCityId);
        // @ts-ignore
        mutateAddreessHandler({ address: addressString[currentCityId] }, () => {
            setCityCallback(currentCityId);
            setSelectedOption((prev) => {
                prevOption.current = prev;
                return currentCityId;
            });
        });
        analyticService.push({
            eventName: 'Select_Region',
            result: currentCityId,
            source_name: 'selected_by_user',
        });
        setIsOpen(false);
    };

    return (
        <NextOverlay
            isOpen={isOpen}
            handleClose={handleCloseDialog}
        >
            {/* @ts-ignore */}
            <FrameDialog handleClose={handleCloseDialog}>
                <div className={css.selectCityRoot}>
                    <div className={css.selectCityTitle}>
                        {lang === 'en' ? 'Delivery city' : 'Город доставки'}
                    </div>
                    <div className={css.selectCityItems}>
                        {cities.map((city) => {
                            const optionTitleClasses = cn({
                                [css.selectCityItemText]: true,
                                selected: selectedOption === city.id,
                            });

                            const cityTitleParts = splitLocationValueFlexible(city.value);
                            return (
                                <button
                                    className={cn(css.selectCityItemButton)}
                                    type="button"
                                    onClick={(e) => {
                                        if (showSubmitButton) {
                                            onCityClickHandler(e, city.id);
                                        } else {
                                            onCitySumbitHandler(e, city.id);
                                        }
                                    }}
                                    id={city.id}
                                    key={city.id}
                                >
                                    <div>
                                        <span className={optionTitleClasses}>
                                            {cityTitleParts.main}
                                        </span>
                                        {' '}
                                        <span className={optionTitleClasses} style={{ color: '#D1D1D1' }}>
                                            {cityTitleParts.suffix}
                                        </span>
                                    </div>
                                    <UIRadioIcon checked={city.id === selectedOption} />
                                </button>
                            );
                        })}
                    </div>
                    {showSubmitButton && (
                        <div className={css.selectCitySubmit}>
                            <UIButton onClick={(e) => onCitySumbitHandler(e)}>
                                {lang === 'en' ? 'Submit' : 'Готово'}
                            </UIButton>
                        </div>
                    )}
                </div>
            </FrameDialog>
        </NextOverlay>
    );
};
